export const asset = (file) => `${process.env.PUBLIC_URL}/assets/${file}`;
